import AppConstants from '../constants/AppConstants';
import FeatureFlagApi from '../api/FeatureFlagApi';

const { FETCH_COOKIES, LOAD_APP_CONFIG, LOAD_COOKIES, SHOW_ERROR_PAGE,
  UPDATE_FEATURE_FLAG_REQUEST, UPDATE_FEATURE_FLAG_SUCCESS, UPDATE_FEATURE_FLAG_FAILURE } = AppConstants;

function loadAppConfig(appConfig) {
  return {
    appConfig,
    type: LOAD_APP_CONFIG
  };
}

/**
 * Tell the reducers to load the given `cookies` as if they came from the
 * user agent's cookies. Used for initializing a server-rendered redux store.
 * @param  {object} cookies
 * @return {object]}
 */
function loadCookies(cookies = {}) {
  return {
    cookies,
    type: LOAD_COOKIES
  };
}

/**
 * Tell the reducers to fetch their cookies from the user-agent.
 * @return {object]}
 */
function fetchCookies() {
  return {
    type: FETCH_COOKIES
  };
}

function showErrorPage() {
  return {
    type: SHOW_ERROR_PAGE
  };
}

function updateFeatureFlag(flag, value) {
  return {
    types: [
      UPDATE_FEATURE_FLAG_REQUEST, UPDATE_FEATURE_FLAG_SUCCESS, UPDATE_FEATURE_FLAG_FAILURE
    ],
    payload: {
      flag,
      enabled: value
    },
    apiRequest: (state, apiRequest) =>
      FeatureFlagApi.updateFlag(flag, value, apiRequest)
  };
}

export default {
  fetchCookies,
  loadAppConfig,
  loadCookies,
  showErrorPage,
  updateFeatureFlag
};



// WEBPACK FOOTER //
// ./app/actions/AppActions.js